module.exports = __webpack_public_path__ + "img/events.79831ced.png";